export enum STATUS {
    ACTIVE = 'Active',
    WARNING = 'Warning',
    ERROR = 'Error',
    ARCHIVED = 'Archived',
}

export enum STATUS_CLASS {
    ACTIVE = 'status-active',
    WARNING = 'status-warning',
    ERROR = 'status-error',
    ARCHIVED = 'status-archived',
}
